<script lang="ts">
    import type { Race } from "../Model/Race";
    import Clock from "./Clock.svelte";

    export let race: Race;

    const points = race.points;

</script>

<style lang="scss">

    .route-state {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        z-index: 2;
        padding: 0.5rem;
        font-size: 0.8rem;
        background-color: #fff;
        box-shadow:
            inset 0 2px 5px rgba(0, 0, 0, 0.25),
            0 2px 5px rgba(0, 0, 0, 0.25);
    }

</style>

<div class="route-state">
    <Clock from={race.startTime} />

    <div class="points">{$points} pts</div>
</div>
